<template>
  <div :class="['qr-code', { mobile: isMobileView }]">
    <div class="qr-code-image-container">
      <FriedSkeleton v-if="!qrCodeUrl" class="qr-code-image" />
      <img
        v-else
        alt="qr-code"
        :src="qrCodeUrl"
        class="qr-code-image"
        data-external="bank-id-sweden-qr-code-image"
      />
    </div>
    <div class="instructions-container">
      <ol :class="{ mobile: isMobileView }" data-external="bank-id-sweden-instructions-container">
        <li>{{ t('cr_bankid_instructions_bullet_one') }}</li>
        <li>{{ t('cr_bankid_instructions_bullet_two') }}</li>
        <li>{{ t('cr_bankid_instructions_bullet_three') }}</li>
        <li>{{ t('cr_bankid_instructions_bullet_four') }}</li>
      </ol>
    </div>
  </div>
</template>
<script setup lang="ts">
import { useI18n } from 'vue-i18n';

interface Props {
  qrCodeUrl: string | null;
  isMobileView?: boolean;
}

const { qrCodeUrl = null, isMobileView = false } = defineProps<Props>();
const { t } = useI18n();
</script>

<style lang="scss" scoped>
$qr-size: 120px;

.qr-code {
  display: flex;
  gap: 3rem;

  &.mobile {
    flex-direction: column;
    gap: var(--spacing-150);
  }

  .qr-code-image-container {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    height: 100%;

    .qr-code-image {
      width: $qr-size;
      height: $qr-size;
    }
  }

  .instructions-container {
    align-self: flex-start;
    width: 100%;

    ol {
      margin-block-end: 0;
      margin-block-start: 0;
      padding-inline-start: 0;
      list-style-position: inside;

      &.mobile {
        text-align: center;
      }

      li {
        padding-bottom: var(--spacing-25);
      }
    }
  }
}
</style>
